export const fmtFCFA = (n: number): string =>
	n.toLocaleString("fr-FR").replace(/,/g, " ") + " F";

export const fmtN = (n: number): string =>
	n.toLocaleString("fr-FR").replace(/,/g, " ");
